import axios from "axios";
import ApiService from "@/services/ApiService.js";

export const state = {
  delito_selected: {}, //seleccionara el objeto de la lista de magistrados
  delitos: []
};
export const mutations = {
  SELECT_DELITO({ context }, delito) {
    return (state.delito_selected = Object.assign({}, delito));
  },
  FILL_DELITOS({ context }, list_delitos) {
    let delitos = [];
    Object.entries(list_delitos).forEach(([key, val]) => delitos.push(val));
    return (state.delitos = delitos);
  }
};
export const actions = {
  GET_ALL_DELITOS({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.get(data)
        .then(response => {
          commit("SET_LOADING", false);
          commit("CLEAR_NOTIFICATION");
          commit("FILL_DELITOS", response.data.data.delitos);
          commit("SET_NOTIFICATION", {
            type: "success",
            message: response.data.message
          });
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  SAVE_DELITO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.post(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
  EDIT_DELITO({ commit }, data) {
  return new Promise((resolve, reject) => {
    commit("SET_LOADING", true); //este loadin esta en el index principalde store
    ApiService.put(data)
      .then(response => {
        commit("CLEAR_NOTIFICATION");
        resolve(response);
      })
      .catch(error => {
        console.log(error);
        reject(error);
      });
  });
},
  DELETE_DELITO({ commit }, data) {
    return new Promise((resolve, reject) => {
      commit("SET_LOADING", true); //este loadin esta en el index principalde store
      ApiService.delete(data)
        .then(response => {
          commit("CLEAR_NOTIFICATION");
          resolve(response);
        })
        .catch(error => {
          console.log(error);
          reject(error);
        });
    });
  },
};
export const getters = {
  getAllDelitos: state => {
    return state.delitos;
  }
};
